import React from 'react';

export function MiddleNodeFields() {
    return (
        <>
        </>
  )
}